// Plan types (lots.plans.type) and the lot type each one belongs to. The UI
// calls reproduction plans "protocols" and herd/weight plans "plans"
// (Trello 8LhwHQOT) — DB fields and code names stay "protocol" throughout.
export const PLAN_TYPE_FOR_LOT = {
  reproduction: 'iatf',
  herd:         'general',
  weight:       'weight',
};

// plansOfType keeps only plans of the given type, so a picker never offers
// e.g. a reproduction protocol for a weight lot. A plan with no type is
// treated as iatf — the same assumption migration 035 made when it added
// type to every pre-existing protocol.
export const plansOfType = (plans, planType) =>
  (plans || []).filter(p => (p.type || 'iatf') === planType);
